import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Dropdown, Form, Button} from 'semantic-ui-react';
import {keyBy} from 'lodash';
import {printLabels, generateLabelsString, getDataForDropdown} from './utils';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import './codesWithoutLabels.scss';

const LIMIT_SEARCH = 4;

class RePrinterLabel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'searchParam': '',
      'itemSelect': null,
      'quantity': 1,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.CodeWithoutLabels,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.clearPrintPartList();
  }

  handleSelectItem(value) {
    const {partsByKey} = this.props;
    this.setState({
      'searchParam': value,
      'itemSelect': partsByKey[value],
    });
  }

  handleSearchListParts(value) {
    if (value.length >= LIMIT_SEARCH) {
      this.props.getPartList(value.toUpperCase());
    }
    this.setState({
      'searchParam': '',
      'quantity': 1,
    });
  }

  handleSubmit(e) {
    const {quantity, itemSelect} = this.state;
    const labelString = generateLabelsString(quantity, itemSelect);
    printLabels(labelString);
    e.preventDefault();
    this.setState({
      'itemSelect': null,
      'quantity': 1,
    });
    this.props.clearPrintPartList();
  }

  renderSelectedItemInfo(itemSelect) {
    return (
      <div className='reprint-container-card'>
        <h3> {itemSelect.name}</h3>
        <p> Código: {itemSelect.code}</p>
        <p> Locación: {itemSelect.location}</p>
        <p> Franquicia: {itemSelect.franchise}</p>
      </div>
    );
  }

  renderSelectedItem() {
    const {itemSelect, quantity} = this.state;
    if (itemSelect) {
      return (
        <div className='reprint-container'>
          {this.renderSelectedItemInfo(itemSelect)}
          <div className='reprint-container-card'>
            <h3>Impresión de etiquetas</h3>
            <Form
              onSubmit={this.handleSubmit}
              className='reprint-container-form'
            >
              <Form.Input
                value={quantity}
                min={1}
                onChange={(event, {value}) =>
                  this.setState({'quantity': +value})
                }
                label='Numero de etiquetas'
                type='number'
                required
                onInvalid={(event) => {
                  event.stopPropagation();
                  event.target.setCustomValidity(
                    'Por favor, llene este campo con un valor igual o mayor a 1'
                  );
                }}
                onInput={(event) => {
                  event.stopPropagation();
                  event.target.setCustomValidity('');
                }}
              />
              <div className='reprint-container-form-button'>
                <Button color='green'>Generar etiquetas</Button>
              </div>
            </Form>
          </div>
        </div>
      );
    }
    return (
      <div className='reprint-container-card'>
        <h3>Búsqueda de partes</h3>
      </div>
    );
  }

  render() {
    const {parts, loading} = this.props;
    const {searchParam} = this.state;

    return (
      <div>
        <Card raised fluid>
          <Card.Header
            className='container-vehicles-happy-wait pd'
            textAlign='left'
          >
            <h2>Códigos sin etiquetas</h2>
          </Card.Header>
          <div className='reprint-controls'>
            <label htmlFor='part-list'>Buscar partes</label>
            <Dropdown
              name='part-list'
              fluid
              noResultsMessage='No se encontro resultados'
              placeholder='Escribe cuatro caracteres o más'
              search
              selection
              loading={loading}
              disabled={loading}
              options={parts}
              value={searchParam}
              onChange={(event, {value}) => this.handleSelectItem(value)}
              onSearchChange={(event, {searchQuery}) =>
                this.handleSearchListParts(searchQuery)
              }
            />
          </div>
        </Card>
        <Card raised fluid>
          {this.renderSelectedItem()}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const listParts = state.codesWithoutLabels.list;
  return {
    'loading': state.codesWithoutLabels.loading,
    'partsByKey': keyBy(listParts, 'code'),
    'parts': getDataForDropdown(listParts),
    'permissions': state.session.permissions,
  };
};

const {getPartList, clearPrintPartList, navigateTo} = Actions;

export default connect(mapStateToProps, {
  getPartList,
  clearPrintPartList,
  navigateTo,
})(RePrinterLabel);
